import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { LogOut, Crown, MessageSquare } from 'lucide-react';

export function UserMenu({ user, onLogout }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2" data-testid="user-menu">
          {user?.picture ? (
            <img src={user.picture} alt="" className="w-6 h-6 rounded-full" />
          ) : (
            <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center text-xs font-bold text-white">
              {user?.name?.[0] || 'P'}
            </div>
          )}
          <span className="text-xs hidden sm:inline">{user?.name?.split(' ')[0]}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-card border-border">
        <DropdownMenuItem className="text-xs text-muted-foreground">{user?.email}</DropdownMenuItem>
        <DropdownMenuItem className="text-xs">
          {user?.status === 'abonne' ? (
            <span className="flex items-center gap-1 text-amber-400"><Crown className="w-3 h-3" /> Abonnement Pro</span>
          ) : (
            <Link to="/abonnement" className="flex items-center gap-1 text-muted-foreground hover:text-primary">
              Gratuit ({user?.quiz_count || 0}/{user?.quiz_limit || 2} QCM)
            </Link>
          )}
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/abonnement" className="flex items-center gap-2 text-sm">
            <Crown className="w-4 h-4" /> {user?.status === 'abonne' ? 'Mon abonnement' : 'Passer à Pro'}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/contact" className="flex items-center gap-2 text-sm" data-testid="menu-contact-link">
            <MessageSquare className="w-4 h-4" /> Contact
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onLogout} className="text-destructive" data-testid="logout-btn">
          <LogOut className="w-4 h-4 mr-2" /> Déconnexion
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function StatusBadge({ user }) {
  if (user?.status === 'abonne') {
    return (
      <span className="hidden sm:flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-400/10 border border-amber-400/30 text-amber-400 text-xs font-bold" data-testid="status-badge-pro">
        <Crown className="w-3 h-3" /> Pro
      </span>
    );
  }
  return (
    <Link to="/abonnement">
      <span className="hidden sm:flex items-center gap-1 px-2 py-0.5 rounded-full bg-secondary border border-border text-muted-foreground text-xs font-medium hover:border-primary/50 hover:text-primary transition-colors cursor-pointer" data-testid="status-badge-free">
        Gratuit &middot; Passer à Pro
      </span>
    </Link>
  );
}
